import { useEffect, useRef, useCallback } from "react";
import { useSocket } from "../contexts/SocketContext";

export const useSocketEventByIds = (
  event: string,
  ids: string[] = ["*"],
  callback: (fullDocument: any) => void,
) => {
  const { socket, subscribe, unsubscribe } = useSocket();
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  const handler = useCallback((fullDocument: any) => {
    savedCallback.current(fullDocument);
  }, []);

  useEffect(() => {
    ids.forEach((id) => {
      subscribe(event, id, handler);
    });

    return () => {
      ids.forEach((id) => {
        unsubscribe(event, id, handler);
      });
    };
  }, [socket, event, subscribe, unsubscribe, handler, ids]);
};
